import type { ZyDocumentAttributes } from '@/components/tiptap-editor/tiptap-extension/zydocument-extension';

export type ParsedSandboxFile = {
    kind: 'section';
    section: Record<string, unknown>;
    documentAttributes?: Partial<ZyDocumentAttributes>;
};

/**
 * Sandbox JSON may be:
 * - Wrapped: `{ "section": { ... }, "documentAttributes"?: { ... } }` (zyXml_to_json section shape).
 * - Plain section: object with `content_resources` (same shape as `convertZyXml`’s `section`).
 */
export function parseSandboxContentFile(raw: unknown): ParsedSandboxFile {
    if (raw && typeof raw === 'object' && Array.isArray((raw as { content_resources?: unknown }).content_resources)) {
        return { kind: 'section', section: raw as Record<string, unknown> };
    }

    throw new Error('Invalid sandbox content: expected a parsed section with content_resources, or { section, documentAttributes }.');
}
